<template>
  <div :class="{ 'mt-1': isLoading, 'section-container': true }">
    <div class="d-flex justify-space-between">
      <header-title-two
        :loading="isLoading"
        title="Video Tutorials & Product Demos"
      />
      <template v-if="windowWidth <= 1263">
        <previous-next-navigation
          :navIndex="videosSlide"
          :navLast="videos.length - numberOfSlides"
          v-on:on-prev="onNav('prev')"
          v-on:on-next="onNav('next')"
          class-name="align-center tech-nav justify-end"
        />
      </template>
    </div>
    <div class="videos">
      <template v-if="windowWidth <= 1263">
        <skeleton-card-list
          :loading="isLoading"
          :isCard="true"
          :number="8"
          class="py-5 py-lg-0 flex-nowrap flex-lg-wrap"
        >
          <slick-carousel
            ref="slickCarousel"
            :itemsToShow="numberOfSlides"
            :settings="slickSettings"
            @afterChange="afterChange"
          >
            <video-thumbnail
              v-for="video in videos"
              :key="video.id"
              :video="video"
            />
          </slick-carousel>
        </skeleton-card-list>
      </template>
      <tempate v-else>
        <videos-wrapper>
          <skeleton-card-list
            :loading="isLoading"
            :number="8"
            class="py-5 py-lg-0 flex-nowrap flex-lg-wrap"
          >
            <video-thumbnail
              v-for="video in videos"
              :key="video.id"
              :video="video"
            />
            <videos-placeholder v-if="!videoSettings.hide_card_in_video" />
          </skeleton-card-list>
        </videos-wrapper>
      </tempate>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VideosApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import SkeletonCardList from '../../components/skeleton/CardList.vue';
import VideoThumbnail from '../../components/videos/VideoThumbnail.vue';
import VideosPlaceholder from '../../components/videos/Placeholder.vue';
import VideosWrapper from '../../components/videos/VideosWrapper.vue';
import SlickCarousel from '../../components/carousel/SlickCarousel.vue';
import PreviousNextNavigation from '../../components/PreviousNextNavigation.vue';
import { defaultSlickSettings, getNumberOfSlides } from '../../utils/carousel';

export default {
  components: {
    HeaderTitleTwo,
    SkeletonCardList,
    VideoThumbnail,
    VideosPlaceholder,
    VideosWrapper,
    SlickCarousel,
    PreviousNextNavigation,
  },
  data: () => ({
    isLoading: false,
    videosSlide: 0,
    slickSettings: defaultSlickSettings([4, 4, 3, 2, 1.2]),
  }),
  computed: {
    ...mapGetters(['videos', 'videoSettings', 'windowWidth']),
    numberOfSlides () {
      return getNumberOfSlides(this.windowWidth, [1.2, 2, 3, 4]);
    },
  },
  mounted() {
    this.fetchVideos();
  },
  methods: {
    ...mapActions(['refreshVideos', 'refreshVideoSettings']),
    async fetchVideos() {
      this.isLoading = true;
      const accessToken = await this.$auth.getTokenSilently();
      const videosApi = new VideosApi(openApiConfig());
      const videos = await videosApi
        .getVideos({ headers: { Authorization: `Bearer ${accessToken}` } })
        .catch(e => console.error(e));
      this.refreshVideos(videos?.data?.data ?? []);
      this.refreshVideoSettings(videos?.data?.settings ?? null);
      this.isLoading = false;
    },
    afterChange(slideNumber) {
      this.videosSlide = slideNumber;
    },
    onNav(type) {
      switch (type) {
        case 'prev':
          this.$refs.slickCarousel.$children[0].prev();
          break;
        case 'next':
        default:
          this.$refs.slickCarousel.$children[0].next();
      }
    },
  },
};
</script>
